import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import global_axios from '../../funciones_globales/interaccionapi';
import { formatearNumeroDecimal } from '../../funciones_globales/format';
import { validarFechaMomentEnFormatoString } from '../../funciones_globales/utils'
import styled from 'styled-components';
import { getItemDatosSesion, getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import Grid from './grid';

const LabelTotales = styled.label`
    display: inline-block;
    font-size: 11px;
    float: right;
`;

const LabelValorTotales = styled.label`
	display: inline-block;
	font-weight: bold;
    align-text: right;
    font-size: 11px;
    float: right;
`;

class FormComp07 extends Component{
    constructor(props) {
        super(props);

        this.state = {
            accion: 'G',
            propuesta: '',
            NroPropuesta: null,
            totalAprobado: 0,
            totalRechazado: 0,
            total: 0,
            pagosData:[],
            pagosColumnDefs:[
                {
                    header:"No",
                    field: "NroItem",
                    width: 40
                },
                {
                    header:"RUC",
                    field: "RUC"
                },
                {
                    header:"Nombre",
                    field: "Nombre"
                },
                {
                    header:"Valor",
                    field: "ValorPagar",
                    align: "right",
                    type: "decimal"
                },
                {
                    header:"A",
                    field: "Estado",
                    width: 30,
                    align: "center",
                    input: {
                        type: "radio",
                        name: "aprobar_rechazar",
                        value:"A",
                        isChecked: (data, value) => data.Estado === value,
                    }
                },
                {
                    header:"R",
                    field: "Estado",
                    width: 30,
                    align: "center",
                    input: {
                        type: "radio",
                        name: "aprobar_rechazar",
                        value:"R",
                        isChecked: (data, value) => data.Estado === value,
                    }
                },
            ]
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.buscarPlanificacionPago = this.buscarPlanificacionPago.bind(this);
        this.guardar = this.guardar.bind(this);
        this.descargarTxt = this.descargarTxt.bind(this);
        this.enviarMail = this.enviarMail.bind(this);
        this.onChangeAprobarRechazar = this.onChangeAprobarRechazar.bind(this);
        this.calcularTotales = this.calcularTotales.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.imprimir = this.imprimir.bind(this);
    }

    componentDidMount(){      
	    this.props.generar_LogAuditoriaIngresoForm('0607');
    }
    
    componentWillUnmount(){
		this.props.generar_LogAuditoriaSalidaForm('0607');
    }
    
    handleInputChange(event){    
		const target = event.target;       
		const name = target.name;    
		const value = target.type === 'checkbox' ? target.checked : target.value;
		this.setState({
			[name]: value
		});
    }

    buscarPlanificacionPago(){
        let id = this.state.propuesta;

        if( !id ){
            alert("Ingrese el número de la propuesta");
            return;
        }

        this.props.cambiar_VisualizacionLoading(true);
        global_axios({
            method: 'GET',
            url: '/planificacionpago/' + id
        })
        .then( response => {
            if( !response.data.length ){
                this.props.cambiar_VisualizacionLoading(false);
                alert("No se encontraron datos");
                return;
            }
            let data = response.data[0];
            let pagosData = [];
            let total = 0;

            data.detalle.forEach((item, i) => {
                pagosData.push({
                    PlanificaPagoProvDetalleId: item.PlanificaPagoProvDetalleId,
                    NroItem: (i + 1),
                    proveedorId: item.IdentificacionBeneficiario,                    
                    RUC: item.proveedor.IdentificacionCash,
                    Nombre: item.proveedor.Nombre,
                    ValorPagar: item.ValorPago,
                    Estado: item.Estado,
                    detalle: "",
                    tipoSeleccion: item.TipoSeleccion
                });
                total += item.ValorPago;
            });

            let accion = "M";
            if( data.Estado === "P" ){
                accion = "G";
            }

            this.setState({
                pagosData,
                total,
                accion: accion,
                NroPropuesta: data.PlanificaPagoProvId,
            }, () => this.calcularTotales());
            this.props.cambiar_VisualizacionLoading(false);
        })
        .catch( error => {
            this.props.cambiar_VisualizacionLoading(false);
            alert("Ha ocurrido un error: " + error);
        });
    }

    onChangeAprobarRechazar(data){
        let pagosData = this.state.pagosData;
        pagosData.forEach((item, key) => {
            if(key === data.index ){
                item.Estado = data.Estado;
            }
        });

        this.setState({pagosData}, () => this.calcularTotales());
    }

    calcularTotales(){
        let totalAprobado = 0;
        let totalRechazado = 0;
        this.state.pagosData.forEach((item, key) => {
            if( item.Estado === "A"){
                totalAprobado += item.ValorPagar;
            }
            if( item.Estado === "R" ){
                totalRechazado += item.ValorPagar;
            }
        });

        this.setState({totalAprobado, totalRechazado});
    }

    guardar(){
        if( this.state.propuesta.trim().toString() === '' || this.state.propuesta.trim().toString() === '0' ){
            alert("Ingrese el número de la propuesta");
            return;
        }

        if( !this.state.pagosData.length ){
            alert("No se econtraron registros");
            return;
        }

        if( this.state.accion === 'M' ){
            return;
        }
        
        let fechaAprobacion = getFechaProcesoPorModulo('06');
        if (!validarFechaMomentEnFormatoString(fechaAprobacion)){
            alert('La fecha de la aprobación es inválida.');
            return;
        }

        if( !window.confirm("¿Está seguro de querer guardar la planificación de pagos?") ){
            return;
        }

        let IdAprueba = [];
        let IdRechaza = [];
        this.state.pagosData.forEach((item, i) => {
            if( item.Estado === "A" ){
                IdAprueba.push(item.PlanificaPagoProvDetalleId);
            }else if( item.Estado === "R" ){
                IdRechaza.push(item.PlanificaPagoProvDetalleId);
            }
        });

        let id = this.state.propuesta;
        let data = {
            Usuario: getItemDatosSesion('usuario').toString(),
            IdAprueba: IdAprueba,
            IdRechaza: IdRechaza,
            FechaAprobacion: fechaAprobacion
        };

        this.props.cambiar_VisualizacionLoading(true);
        global_axios({
            method: 'POST',
            url: '/planificacionpago/' + id + '/aprobacion',
            data: data
        })
        .then( response => {
            this.setState({accion: 'M'});
            alert("Se ha procesado correctamente el proceso de aprobación. A continuación puede proceder a generar el archivo de texto y realizar el envio de e-mails a los proveedores.");
            this.props.cambiar_VisualizacionLoading(false);
        })
        .catch( error => {
            this.props.cambiar_VisualizacionLoading(false);            
            alert(error.response?error.response.data.msg:error.message);
        });
    }

    imprimir(){
        if( this.state.NroPropuesta !== null ){
            let Nro = this.state.NroPropuesta;
            visualizarReporteEnPdf('&rpt=47&param1=' + Nro);
        }else{
            alert("No se encontro el número de la planificación");
        }
    }

    descargarTxt(){
        let id = this.state.propuesta;

        if( this.state.propuesta.trim().toString() === '' || this.state.propuesta.trim().toString() === '0' ){
            alert("Ingrese el número de la propuesta");
            return;
        }

        this.props.cambiar_VisualizacionLoading(true);
        global_axios({
            method: 'GET',
            url: '/planificacionpago/' + id + '/text',
            responseType: 'text'
        })
        .then( response => {
            this.props.cambiar_VisualizacionLoading(false);
            
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'ArchivoTextCM_' + this.state.propuesta + '.txt');
            document.body.appendChild(link);
            link.click();
        })
        .catch( error => {
            this.props.cambiar_VisualizacionLoading(false);
            alert("Ha ocurrido un error: " + error);
        });
    }

    enviarMail(){
        let empresa = getItemDatosSesion("empresaActual");
        empresa = JSON.parse(empresa);

        if( this.state.propuesta.trim().toString() === '' || this.state.propuesta.trim().toString() === '0' ){
            alert("Ingrese el número de la propuesta");
            return;
        }

        let id = this.state.propuesta;
        this.props.cambiar_VisualizacionLoading(true);
        global_axios({
            method: 'POST',
            url: '/planificacionpago/' + id + '/mail',
            data: {empresa_id: empresa.Id}
        })
        .then( response => {
            this.props.cambiar_VisualizacionLoading(false);

            let proveedoresSinEmail = response.data.proveedoresSinEmail;
            let msg = `Se ejecutó correctamente el proceso de envío de e-mails a los proveedores beneficiarios de la Propuesta de Pago: ${id}.`;
            if( proveedoresSinEmail.length ){
                msg += `\nLos siguientes proveedores no fueron notificados puesto que no tienen e-mail registrado: ${proveedoresSinEmail.join('; ')}`;
            }
            alert(msg);
        })
        .catch( error => {
            this.props.cambiar_VisualizacionLoading(false);
            alert(error.response?error.response.data.msg:error.message);
        });
    }

    limpiar(){
        this.setState({
            accion: 'G',
            propuesta: '',
            totalAprobado: 0,
            totalRechazado: 0,
            total: 0,
            pagosData:[],
        });
    }

    render(){
        return(
            <ContenedorForm porc_ancho={40}>
				<HeaderForm>
					<TituloForm>Aprobación de planificación de pagos</TituloForm>
				</HeaderForm>

				<CuerpoForm>
                    <Row>
                        <ContainerCol className="col-sm-3">
                            <LabelForm>Propuesta Nro.</LabelForm>
                            <InputSearch
                                tipoInput='text'
                                nombre='propuesta'
                                placeholder='No. propuesta'
                                valor={this.state.propuesta}
                                func_CambiarValor={this.handleInputChange}
                                func_BuscarValor={this.buscarPlanificacionPago}
                                func_OnFocus={this.limpiar}
                            />
                        </ContainerCol>
                    </Row>
 
                    <Row>
                        <ContainerCol className="col-sm-12">
                            <Grid ref="grid"
                                altura='320px'
                                columnas={this.state.pagosColumnDefs}
                                data={this.state.pagosData}
                                onChangeRadiobutton={this.onChangeAprobarRechazar}
                            />
                        </ContainerCol>
                    </Row>

                    <Row>
                        <ContainerCol className="col-sm-12">
                            <LabelValorTotales> {formatearNumeroDecimal(this.state.totalAprobado)}</LabelValorTotales>
                            <LabelTotales>Total aprobado: $ </LabelTotales>
                        </ContainerCol>
                    </Row>

                    <Row>
                        <ContainerCol className="col-sm-12">
                            <LabelValorTotales> {formatearNumeroDecimal(this.state.totalRechazado)}</LabelValorTotales>
                            <LabelTotales>Total rechazado: $ </LabelTotales>
                        </ContainerCol>
                    </Row>

                    <Row>
                        <ContainerCol className="col-sm-12">
                            <LabelValorTotales> {formatearNumeroDecimal(this.state.total)}</LabelValorTotales>
                            <LabelTotales>Total: $ </LabelTotales>
                        </ContainerCol>
                    </Row>

                    <Row>
                        <ContainerCol className="col-sm-12">
                            <div className='btn-group pull-right btn-group-sm'> 
                                <button type='button' className='btn btn-primary' disabled={this.state.accion === 'M'} onClick={this.guardar}>
                                    <i className="fa fa-save fa-fw"></i>Guardar
                                </button>                
                                <button type='button' className='btn btn-default' disabled={this.state.accion === 'G'} onClick={this.descargarTxt}>
                                    <i className="fa fa-file-text-o fa-fw"></i>Generar txt
                                </button>
                                <button type='button' className='btn btn-default' disabled={this.state.accion === 'G'} onClick={this.enviarMail}>
                                    <i className="fa fa-envelope-o fa-fw"></i>Enviar correo
                                </button>
                                <button type='button' className='btn btn-default' disabled={this.state.NroPropuesta === null} onClick={this.imprimir}>
                                    <i className="fa fa-print fa-fw"></i>Imprimir
                                </button>
                                <button type='button' className='btn btn-default' onClick={this.limpiar}>
                                    <i className="fa fa-trash fa-fw"></i>Limpiar
                                </button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
			</ContenedorForm>
        );
    }
}

const mapStateToProps = ((state) => {
	return {
		isVisibleLoading: state.ui.isVisibleLoading,		
		permiso: state.sesion.valoresSesionForm.Permiso,
		permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
		diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias,
	};
});
  
const mapDispatchToProps = ((dispatch) => {  
	return bindActionCreators({
		cambiar_VisualizacionLoading,
		generar_LogAuditoriaIngresoForm,
		generar_LogAuditoriaSalidaForm,
	}, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormComp07);